<template>
	<div class="radio-select" :class="'select-' + name">
		<label v-for="value in values" :class="{ selected: value.id === vmodel }" class="radio-container" :title="value.name">
			<input type="radio" class="select" :name="name" :value="value.id" v-model="vmodel" @click="unselectWhenSelected">
            <span class="checkmark" :class="value.image || value.icon || value.hex ? 'less-white-space' : ''"></span>

            <img v-if="value.image" :src="value.image" :alt="value.name">
            <span v-if="value.hex" class="color-hex" :class="{ 'bordered' : value.border }" :style="'background-color: ' + value.hex"> </span>

            <Icon v-if="value.icon" :icon="value.icon" />
			<span v-else-if="value.style" :style="value.style" class="option-name">
				{{ value.name }}
			</span>
			<span v-else class="option-name">
				{{ value.name }}
			</span>
		</label>
	</div>
</template>

<script>
	import Icon from "./Icon";

	export default {
		name: "RadioSelect",
		components: {
			Icon
		},
		props: [
			"values",
			"name",
			"value"
		],
        methods: {
            unselectWhenSelected() {
            	if (this.value)
                	this.$emit("input", null);
            }
        },
		computed: {
			vmodel: {
				get() {
					return this.value;
				},

				set(value) {
					this.$emit("input", value);

					// Monogram style category (color, font) is selected -> save its styling to DB
					let selectedValue;

					if (Array.isArray(this.values))
						selectedValue = this.values.filter(item => item.id === value)[0];
					else
						selectedValue = this.values[value];

					if (selectedValue && selectedValue.style)
						this.$set(this.$db.products, "monogram-" + this.name + "-style", selectedValue.style);
				}
			}
		}
	}
</script>
